export default "__VITE_ASSET__8ce3487c__"